import React, { Component } from 'react'
import { connect } from 'react-redux';
import Service from '../../services';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import { BoardsIconInActive, GradesIcon } from '../svgIcons';
import { Toast } from 'primereact/toast';
import LoadingComponent from '../loadingComponent';
import { getBoardsData, getBranchesLatest } from '../../store/actions';
import { userAssignedBoards } from '../../store/selectors/userAssignedBoards';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import { cloneDeep } from 'lodash';

class BranchToSectionMultiDDTillSecCol extends Component {
    constructor(props) {
        super(props);
        this.state = {
            boardIds: null,
            classIds: null,
            groupId: null,
            branchIds: null,
            sectionIds: null,
            boards: [],
            classes: [],
            sections: [],
            curriculumInfo: {},
            selectedrowData: this.props?.dropdownsData

        };
        this.service = new Service()
    }

    componentDidMount() {
        console.log("selectedrowDataselectedrowData", this.props?.dropdownsData)
        this.getData()
    }

    

    getData = () => {
       /*  this.props.getBranchesLatest();
        this.props.getBoardsData(true) */
    }

    // Helper method to check if user is a teacher
    isTeacher = () => {
        // Check user type from localStorage
        const userType = localStorage.getItem('type');
        
        // Only if type is 'teacher', check for assignedSubjects
        if (userType === 'teacher') {
            return this.props.userInfo?.assignedSubjects && this.props.userInfo.assignedSubjects.length > 0;
        }
        
        // For all other types (admin, staff, etc.), return false (they get all sections)
        return false;
    }

    // Helper method to remove duplicates based on unique ID
    removeDuplicates = (array, idKey) => {
        if (!array || array.length === 0) return [];
        
        const seen = new Set();
        return array.filter(item => {
            const id = item[idKey];
            if (seen.has(id)) {
                return false;
            }
            seen.add(id);
            return true;
        });
    }

    // Filter branches based on user's assigned branches
    getFilteredBranches = () => {
        const { userInfo, branchData } = this.props;

        // If user is admin, return all branches
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(branchData || [], 'key');
        }

        // For non-admin users, filter by assigned branches
        if (!userInfo.branchs || userInfo.branchs.length === 0) {
            return this.removeDuplicates(branchData || [], 'key');
        }

        const filtered = branchData.filter(branch =>
            userInfo.branchs.includes(branch.key)
        );
        
        return this.removeDuplicates(filtered, 'key');
    }

    // Filter boards based on user's assigned branches and boards
    getFilteredBoards = (selectedBranchIds) => {
        const { userInfo, boards } = this.props;

        let filteredBoards = cloneDeep(boards || []);

        // If user is admin, return all boards (filtered only by selected branches if any)
        if (userInfo?.isAdmin === true) {
            // Filter by selected branches only
            if (selectedBranchIds && selectedBranchIds.length > 0) {
                filteredBoards = filteredBoards.filter(board =>
                    board.assignedBranches.some(branchId => selectedBranchIds.includes(branchId))
                );
            }
        } else {
            // For non-admin users, filter by selected branches
            if (selectedBranchIds && selectedBranchIds.length > 0) {
                filteredBoards = filteredBoards.filter(board =>
                    board.assignedBranches.some(branchId => selectedBranchIds.includes(branchId))
                );
            }

            // For teachers, additionally filter by assigned boards
            if (this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
                filteredBoards = filteredBoards.filter(board =>
                    userInfo?.boardId.includes(board.boardId)
                );
            }
            // For non-admin, non-teacher users, filter by assigned boards if available
            else if (!this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
                filteredBoards = filteredBoards.filter(board =>
                    userInfo?.boardId.includes(board.boardId)
                );
            }
        }

        // Remove duplicate boards by boardId
        filteredBoards = this.removeDuplicates(filteredBoards, 'boardId');

        // Add display names
        filteredBoards.forEach((board) => {
            board?.classes?.forEach((classs) => {
                classs.className = board?.boardName + ' -- ' + classs.className;
                classs.sections.forEach((sec) => sec.sectionName = classs.className + ' -- ' + sec.sectionName);
            });
        });

        return filteredBoards;
    }

    // Filter sections based on user role
    getFilteredSections = (sections) => {
        const { userInfo } = this.props;

        // If user is admin, return all sections
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(sections, 'sectionId');
        }

        // If not a teacher, return all sections (no filtering needed)
        if (!this.isTeacher()) {
            return this.removeDuplicates(sections, 'sectionId');
        }

        // If teacher but no assignedSections, return empty array (no sections accessible)
        if (!userInfo?.sections || userInfo.sections.length === 0) {
            return [];
        }

        // For teachers with assignedSections, filter by assigned sections
         const filtered = sections.filter(section =>
                userInfo.sections.includes(section.sectionId)
            );
        
        return this.removeDuplicates(filtered, 'sectionId');
    }

    onChangeBranch = (branchIds) => {

        this.setState({
            boards: [], classes: [], sections: [],
        });

        // Use filtered boards based on selected branches and user role
        let filteredBoards = this.getFilteredBoards(branchIds);

        this.setState({
            branchIds: branchIds,
            boards: filteredBoards,
            classes: [],
            boardIds: '',
            classIds: '',
            branches: [],
            sections: [],
            sectionIds: [],
        });
    };

    onChangeBoard = (boardIds) => {
        this.setState({
            classes: [], sections: [],
        });

        let filteredClasses = [];

        this.state.boards.forEach(board => {
            if (boardIds.includes(board.boardId)) {
                filteredClasses.push(...board.classes);
            }
        });

        // Remove duplicate classes by classId
        filteredClasses = this.removeDuplicates(filteredClasses, 'classId');

        this.setState({
            classes: filteredClasses,
            boardIds,
            classIds: '',
            branches: [],
            sections: [],
            sectionIds: [],

        }, () => this.setDropdownsData());
    };

    onChangeClass = (classIds) => {
        this.setState({
            sections: [],
        });

        let lsecs = []

        // For each selected class ID
        classIds?.forEach(classId => {
            // Find the class in the current classes
            const selectedClass = this.state.classes?.find(cls => cls.classId === classId);

            if (selectedClass && selectedClass.sections) {
                // Filter sections for this specific class
                const validSections = selectedClass.sections.filter(sec => {
                    // Check if section belongs to selected branch
                    const belongsToSelectedBranch = this.state.branchIds?.includes(sec?.branchId);

                    // Check if section is from the selected board
                    const isFromSelectedBoard = this.state.boardIds?.some(boardId => {
                        const board = this.state.boards.find(b => b.boardId === boardId);
                        if (!board) return false;

                        // Verify this board:
                        // 1. Is assigned to the section's branch
                        // 2. Contains this specific class
                        // 3. Contains this specific section
                        const isBoardAssignedToBranch = board.assignedBranches?.includes(sec?.branchId);
                        const boardHasThisClass = board.classes?.some(cls => cls.classId === classId);
                        const boardHasThisSection = board.classes?.some(cls =>
                            cls.classId === classId &&
                            cls.sections?.some(s => s.sectionId === sec.sectionId)
                        );

                        return isBoardAssignedToBranch && boardHasThisClass && boardHasThisSection;
                    });

                    return belongsToSelectedBranch && isFromSelectedBoard;
                });

                lsecs.push(...validSections);
            }
        });

        // Apply teacher-specific filtering to sections
        lsecs = this.getFilteredSections(lsecs);

        this.setState({
            classIds: classIds,
            sections: lsecs,
            sectionIds: [],
        }, () => this.setDropdownsData());
    };

    onChangeSection = (sectionIdstt) => {

        console.log(sectionIdstt, "sectionIdssectionIds")

        this.setState({
            sectionIds: sectionIdstt,
        }, () => this.setDropdownsData());
    };

    setDropdownsData = () => {

        let filteredClasses = [];
        this.props.boards.forEach(board => {
            if (this.state?.boardIds.includes(board.boardId)) {
                filteredClasses.push(...board.classes);
            }
        });

        let lsecs = [];
        filteredClasses.forEach((fClass) => {
            const secc = fClass.sections?.filter((sec) => this.state.branchIds?.includes(sec?.branchId));
            lsecs = [...lsecs, ...secc];
        });

        let {
            boardIds,
            classIds,
            branchIds,
            sectionIds,
        } = this.state;
        let branchNames, sectionNames = []
        if (sectionIds?.length) {
            branchNames = branchIds?.map((e) => this.props.branchData?.find(f => e == f.key).name)
            sectionNames = sectionIds?.map((e) => lsecs?.find(f => e == f.sectionId)?.sectionName)
        }



        this.props.setValues({
            boardIds, classIds, branchIds, sectionIds, branchNames, sectionNames
        })
    }



    updateSections() {
        let filteredClasses = [];
        this.props.boards.forEach(board => {
            if (this.state?.boardIds.includes(board.boardId)) {
                filteredClasses.push(...board.classes);
            }
        });

        this.setState({ classes: filteredClasses });

        let lsecs = [];
        filteredClasses.forEach((fClass) => {
            const secc = fClass.sections?.filter((sec) => this.state.branchIds?.includes(sec?.branchId));
            lsecs = [...lsecs, ...secc];
        });

        // Set the state to lsecs
        this.setState({ sections: lsecs });
    }

    render() {
        // Get filtered branches for the dropdown options
        const filteredBranchData = this.getFilteredBranches();

        return (
            <div>
                <div >
                    <div className='grid ml-1' style={{ display: 'flex', gap: '8px' }}>
                        <div className='col-12'>
                            <div className="row-3 ">
                                <ClassetMultiSelect required={true} label={'Branch'} 
                                // icon={<BoardsIconInActive height={16.5} width={19.5} />} 
                                placeholder={'Select Branch'} options={filteredBranchData}

                                    value={this.state.branchIds} onChange={(e) => this.onChangeBranch(e.value)} optionLabel="name"
                                    optionValue="key" />
                            </div>
                            <div className="row-3 ">
                                <ClassetMultiSelect label={'Board'} 
                                // icon={<BoardsIconInActive height={16.5} width={19.5} />} 
                                placeholder={'Select Board'} options={this.state.boards} value={this.state.boardIds} onChange={(e) => this.onChangeBoard(e.value)} optionLabel="boardName"
                                    optionValue="boardId" />
                            </div>
                            <div className="row-3 ">
                                <ClassetMultiSelect label={'Grade'} 
                                // icon={<GradesIcon />} 
                                placeholder={'Select (Board - Grade)'} options={this.state.classes}
                                    value={this.state.classIds} onChange={(e) => this.onChangeClass(e.value)} optionLabel="className"
                                    optionValue="classId" />
                            </div>
                            <div className="row-3 ">
                                <ClassetMultiSelect label={'Section'} 
                                // icon={<GradesIcon />} 
                                placeholder={'Select (Board - Grade - Section)'} options={this.state.sections}
                                    value={this.state.sectionIds} onChange={(e) => this.onChangeSection(e.value)} optionLabel="sectionName"
                                    optionValue="sectionId" />
                            </div>
                        </div>
                    </div>
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
                {this.state.isLoading && <>
                    <LoadingComponent />
                </>}
            </div>
        )
    }
}

const mapStatesToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoards'),
    branchData: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.data.filter((each => {
        if (each.level == 1) {
            return { ...each }
        }
    })) || [],
    permissionIds: state.currentUserPerms && state.currentUserPerms.permissionIds && state.currentUserPerms.permissionIds,
    userInfo: state.currentUserPerms && state.currentUserPerms.userInfo ? state.currentUserPerms.userInfo : {},
});
export default connect(mapStatesToProps, { getBoardsData, getBranchesLatest })(BranchToSectionMultiDDTillSecCol);